import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Icon, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { env } from 'utils/env';
import { ListItem, ListItemIcon, ListItemLink, ListItemText, StyledArrowDropDown, StyledArrowDropUp, StyledNavLink } from './MenuStyle';

const MenuItem = ({ menu, drawerOpen, activeRoute, isSubMenuItem, subMenuOpen, onToggleSubMenu, withGradient }) => {
  const { t } = useTranslation();
  const { id, children, route, icon, caption } = menu;
  const isSubMenu = Boolean(children);
  const isActive = activeRoute && activeRoute(route);
  const isExternal = route.toLowerCase().indexOf('/external/') !== -1;

  const internalRoute = useMemo(() => {
    if (!isExternal) return route;
    const isFromEnv = route.toLowerCase().indexOf('/external/env/') !== -1;

    if (isFromEnv) {
      const envVariable = route.substring(14, route.length);
      const path = env[envVariable];

      if (envVariable.includes('ADMIN_URL')) {
        const lastCharacter = path.substring(path.length - 1, path.length);
        const separator = lastCharacter === '/' ? '' : '/';
        return `${path}${separator}insurance`;
      }

      return path;
    } else {
      return route.substring(10, route.length);
    }
  }, [isExternal, route]);

  const translatedText = t(caption);
  const Item = isSubMenu ? ListItemLink : StyledNavLink;
  const itemProps = isSubMenu
    ? { onClick: onToggleSubMenu, button: true }
    : { to: { pathname: internalRoute }, ...(isExternal && { target: '_blank', rel: 'noopener noreferrer' }) };

  return (
    <Tooltip disableHoverListener={drawerOpen} title={translatedText} placement='right'>
      <ListItem id={`menuEntry_${id}`}>
        <Item {...itemProps} isSubMenu={isSubMenu} isActive={isActive} withGradient={withGradient}>
          <ListItemIcon isSubMenuItem={isSubMenuItem} drawerOpen={drawerOpen}>
            <Icon>{icon}</Icon>
          </ListItemIcon>
          <ListItemText
            primary={translatedText}
            secondary={
              isSubMenu &&
              (subMenuOpen ? <StyledArrowDropUp isSubMenuItem={isSubMenuItem} /> : <StyledArrowDropDown isSubMenuItem={isSubMenuItem} />)
            }
            disableTypography={true}
            drawerOpen={drawerOpen}
          />
        </Item>
      </ListItem>
    </Tooltip>
  );
};

MenuItem.propTypes = {
  menu: PropTypes.object.isRequired,
  drawerOpen: PropTypes.bool.isRequired,
  activeRoute: PropTypes.func,
  isSubMenuItem: PropTypes.bool,
  subMenuOpen: PropTypes.bool,
  onToggleSubMenu: PropTypes.func,
  withGradient: PropTypes.bool.isRequired
};

export default MenuItem;
